module.exports = __webpack_public_path__ + "static/media/tutorial-card-2.9d90be4f.png";